<div class="container-fluid mt-4">

  <div class="d-flex justify-content-between mb-3">
    <h4> <i class="fi fi-rs-settings"></i> პარამეტრები</h4>
  </div>

  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <!-- Error Message -->
  <div *ngIf="error" class="alert alert-danger">
    მოხდა შეცდომა პარამეტრების სიის მიღებისას.
  </div>

  <!-- Tickets Table -->
   <div class="table-responsive">
    <table *ngIf="!load && !error && data?.length > 0" class="table table-hover table-bordered mt-3">
      <thead >
        <tr>
          <th>#</th>
          <th>დასახელება</th>
          <th>მნიშვნელობა</th>
          <th>პარამეტრები</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            {{getTitle(item.key ) }} 
          </td>
          <td>{{ item.value }}</td>
          <td>
              <!-- რედაქტირება -->
              <div class="d-flex">
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="openEditModal(item)">
                    <i class="fi fi-rr-pencil"></i>
                </button> 
                <!-- 
                <button type="button" class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="openPasswordModal(user)">
                    <i class="fi fi-rr-lock"></i>
                </button>  -->
                <!-- <button type="button" class="btn btn-sm btn-danger rounded d-flex align-items-center mx-2"
                        (click)="confirmDelete(user)">
                        <app-spinner *ngIf="deleteUserId === user.id" [sm]="true" [loading]="true"></app-spinner>
                        <i *ngIf="deleteUserId !== user.id" class="fi fi-rr-trash"></i>
                </button>         -->
              </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data -->
  <div *ngIf="!load && !error && data?.length === 0" class="alert alert-warning">
    ჩანაწერი ვერ მოიძებნა.
  </div>



</div>


<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">პარამეტრების რედაქტირება</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <h6>{{ getTitle(editData.key) }}</h6>
    <div class="mb-3">
      <label>სახელი</label>
      <input type="text" [(ngModel)]="value" class="form-control" />
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary d-flex" (click)="update(modal)" [disabled]="editBtnLoad">
      <app-spinner [sm]="true" [loading]="editBtnLoad"></app-spinner> 
      შენახვა
    </button>
  </div>
</ng-template>



